import { render, staticRenderFns } from "./wrongCode.vue?vue&type=template&id=120a1a49&scoped=true"
import script from "./wrongCode.vue?vue&type=script&lang=js"
export * from "./wrongCode.vue?vue&type=script&lang=js"
import style0 from "./wrongCode.vue?vue&type=style&index=0&id=120a1a49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a1a49",
  null
  
)

export default component.exports